import {twMerge} from '../../../common/twMerge';
import {DotProps} from './DotProps.interface';

export function Dot({className, ...props}: DotProps) {
  return (
    <div
      role="img"
      className={twMerge(
        'h-4px w-4px rounded-full bg-static-point-yellow',
        className
      )}
      {...props}
    />
  );
}
